import React, { useEffect } from 'react';
import { inject } from 'mobx-react';
import './index.less';
import { HomeBusiness } from '@business/newCreateRequest/common/home';
import { observer } from 'mobx-react-lite';
import {
    isDAR,
    isDisableMenuBar
} from '@common/utils';
var NewHeader = inject(HomeBusiness)(observer(function (props) {
    var currentUser = props.currentUser, getCurrentUser = props.getCurrentUser, getCustomConfigs = props.getCustomConfigs;
    useEffect(function () {
        getCurrentUser();
        var logoElement = document.getElementById('newSRHeaderLogo');
        logoElement && (logoElement.style.visibility = 'hidden');
        var welcomeTextElement = document.getElementById('newSRHeaderWelcomeText');
        welcomeTextElement && (welcomeTextElement.style.visibility = 'hidden');
        getCustomConfigs().then(function (data) {
            var customConfigs = props.customConfigs;
            var logoVisibility = data === null || data === void 0 ? void 0 : data.find(function (item) {
                return item.Id === 'newSRHeaderLogo';
            }).Visible;
            var textVisibility = data === null || data === void 0 ? void 0 : data.find(function (item) {
                return item.Id === 'newSRHeaderWelcomeText';
            }).Visible;
            if (logoVisibility) {
                logoElement && (logoElement.style.visibility = 'visible');
            }
            if (textVisibility) {
                welcomeTextElement && (welcomeTextElement.style.visibility = 'visible');
            }
        }).catch(function (error) {
            logoElement && (logoElement.style.visibility = 'visible');
            welcomeTextElement && (welcomeTextElement.style.visibility = 'visible');
        });
    }, []);
    return !isDisableMenuBar() && React.createElement('div', { className: 'rsp-header' }, React.createElement('div', { className: 'rsp-container' }, !isDAR() && React.createElement('div', {
        id: 'newSRHeaderLogo',
        className: 'rsp-logo'
    }, React.createElement('img', { src: 'https://rsp-front-end-stage.lessen.com/sources/img/new-dashboard.svg' }), React.createElement('div', { className: 'rsp-logo-info' }, React.createElement('h1', null, 'One Maintenance'), React.createElement('span', null, 'by Lessen'))), React.createElement('ul', { className: 'rsp-header-action' }, !isDAR() && React.createElement('li', { id: 'newSRHeaderWelcomeText' }, React.createElement('span', { className: 'text-opacity08' }, 'Welcome'), ', ', currentUser.fullName))));
}));
export default NewHeader;